<div class="overlay">
  <div class="release-container">
    <div *ngIf="releases?.length" class="carousel">
      <button class="nav prev" type="button" (click)="previous()" [disabled]="!canGoPrevious" aria-label="Précédent">
        <i class="fa fa-chevron-left"></i>
      </button>

      <div class="carousel-track">
        <div class="carousel-item" *ngIf="release" [@carouselAnimation]="currentIndex" [class.no-image]="!hasImage(release)">
          <ng-container *ngIf="hasImage(release); else textOnly">
            <img [src]="resizeCoverImage(release)" [alt]="release.title" />
          </ng-container>

          <ng-template #textOnly></ng-template>

          <h1 class="title">{{ release.title }}</h1>
          <div class="body" [innerHTML]="release.body"></div>
        </div>
      </div>

      <button class="nav next" type="button" (click)="next()" [disabled]="!canGoNext" aria-label="Suivant">
        <i class="fa fa-chevron-right"></i>
      </button>

      <div class="carousel-dots" *ngIf="releases!.length > 1">
        <span *ngFor="let r of releases; let i = index" [class.active]="i === currentIndex" (click)="goTo(i)"></span>
      </div>
    </div>
  </div>
</div>
